import { UserConfiguration } from './models/userConfiguration';

export interface IUserConfigurationsService {

    activeUserConfiguration: UserConfiguration | null;

    /**
        * get all user display settings for logged on user
        */
    retrieveActiveUserConfiguration(): void;

    /**
        * function to return the users active configuration or null if not logged on
        */
    getActiveUserConfiguration(): UserConfiguration | null;
}

export var userConfigurationsService = [
    "$http",
    function (
        $http,
    ) {
        var svc = this;
        svc.activeUserConfiguration = null;

        svc.retrieveActiveUserConfiguration = function() {
            return $http.get("api/v1/UserConfiguration/GetActive")
                .then(function (response) {
                    svc.activeUserConfiguration = response.data;
                });
        }

        svc.getActiveUserConfiguration = function () {
            return svc.activeUserConfiguration;
        }
    }
];